// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';

const Expenses = {
  "BOND": "BOND",
  "RENTAL": "RENTAL",
  "FOOD": "FOOD",
  "CHILD_SUPPORT": "CHILD_SUPPORT",
  "NON_FOOD": "NON_FOOD",
  "OTHER": "OTHER"
};

const LoanPurposes = {
  "HOUSING": "HOUSING",
  "FUNERAL": "FUNERAL",
  "STUDY": "STUDY",
  "MEDICAL": "MEDICAL",
  "ACCOUNTS": "ACCOUNTS",
  "OTHER": "OTHER"
};

const LoanStatus = {
  "NEW": "NEW",
  "PROCESSING": "PROCESSING",
  "APPROVED": "APPROVED",
  "DECLINED": "DECLINED"
};

const Status = {
  "ACTIVE": "ACTIVE",
  "DELETED": "DELETED"
};

const { LoanApplication, Employee, Company, LoanType, CompanyLoanType } = initSchema(schema);

export {
  LoanApplication,
  Employee,
  Company,
  LoanType,
  CompanyLoanType,
  Expenses,
  LoanPurposes,
  LoanStatus,
  Status
};